import axios from 'axios';
import qorbi_coin from '../assets/img/qorbi-coin.png';
import React, { useEffect, useState } from 'react';
import { useSphereOneProvider } from "../utils/SphereOneHooks";
import { useNavigate } from 'react-router-dom';
import InputWallet from '../components/InputWallet';
import OTPInput from "../components/OTP";
import Popup from "../components/Popup";
import { Toast } from "../utils/Global";

const qorbiServices = require('../context/QorbiService');

const BetaTester = () => {

    const { qorbiUserData } = useSphereOneProvider();
    const navigate = useNavigate();

    const [matchesData, setMatchesData] = useState([]);
    const [leaderSubjects, setLeaderSubjects] = useState(null);
    const [hotNews, setHotNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [OTP, setOTP] = useState();
    const [walletInput, setWalletInput] = useState(false);
    const [error, setError] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [showOTP, setShowOTP] = useState(false);
    const [currentTable, setCurrentTable] = useState('matches');

    const fetchData = async () => {
        try {
            const hotNewsResponse = await axios.get('https://api.qorbiworld.com/v1/hotnews');
            setHotNews(hotNewsResponse.data);
            if (qorbiUserData?.testerGroup) {
                const response = await axios.get(`https://api.qorbiworld.com/v1/beta-testers/${qorbiUserData.username}`);
                const sortedData = response.data.sort((a, b) => new Date(b._id) - new Date(a._id));
                setLoading(false);
                setMatchesData(sortedData);
            } else {
                navigate('/');
            }
            if (qorbiUserData?.betaLeader === true) {
                const leaderSubjectsResponse = await axios.get(`https://api.qorbiworld.com/v1/beta-leaders/${qorbiUserData.username}`);
                setLeaderSubjects(leaderSubjectsResponse.data);
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleOtpSubmit = async (otpCode) => {
        setShowOTP(false)
        setOTP(otpCode)
        setWalletInput(true)
    };

    const sendFunds = async (address) => {
        try {
            Toast.set({
                show: true,
                desc: 'We are starting the withdraw, wait for a second!',
                type: 'success',
            });
            setWalletInput(false)
            await qorbiServices.withdrawBetaRewards(address, OTP);
            Toast.set({
                show: true,
                desc: 'Success! You have withdrew the $QORBI reward from your Beta Tester Matches!',
                type: 'success',
            });
            setTimeout(() => {
                window.location.reload();
            }, 3000);
        } catch (error) {
            console.error(error);
        }
    }

    const handleWithdraw = async () => {
        qorbiServices.requestOtp();
        setShowOTP(true)
    }

    const handleCloseOtpSubmit = () => {
        setShowOTP(false)
    };

    useEffect(() => {
        if (qorbiUserData) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [qorbiUserData]);

    const calculateTotalQorbi = () => {
        return matchesData.reduce((total, match) => total + match.matchCount, 0);
    };

    const calculateMonthlyEarnings = (totalEarning) => {
        return totalEarning + (2 * 250);
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="beta-gamers-matches">
            {walletInput && <InputWallet onSuccess={sendFunds} />}
            {showOTP && <OTPInput onSubmit={handleOtpSubmit} onCancel={handleCloseOtpSubmit} />}
            {showPopup && (
                <Popup
                    onClose={() => setShowPopup(false)}
                    title={showPopup.title}
                    content={
                        <>
                            <p>
                                {showPopup.content}
                            </p>
                        </>
                    }
                />
            )}
            <h1 className='green-title text-center'>Matches For {qorbiUserData.username} From Team {qorbiUserData.testerGroup}</h1>
            <div className="middle-container">
                <div className="qorbi-earnings">
                    <div className='qorb-earning-container'>
                        <img src={qorbi_coin} alt="Qorbi_Coin" />
                        ‎ Matches Earning: <div style={{ color: "#0f0", marginLeft: 8 }}>{calculateTotalQorbi()} QORBI</div>
                    </div>
                    <div className="button-container-tester">
                        <button
                            className="greenBtn"
                            style={{ width: "55%", height: 50 }}
                            // onClick={() => handleWithdraw()}
                        >
                            Claim Your Qorbi
                        </button>
                    </div>
                    <div className="table-container">
                        {leaderSubjects && (
                            <div className="table-switch-container">
                                <button
                                    className={`btnTransparent ${currentTable === 'matches' ? 'greenBtn' : ''}`}
                                    onClick={() => setCurrentTable('matches')}
                                >
                                    Matches Table
                                </button>
                                <button
                                    className={`btnTransparent ${currentTable === 'leaders' ? 'greenBtn' : ''}`}
                                    onClick={() => setCurrentTable('leaders')}
                                >
                                    My Gamers
                                </button>
                            </div>
                        )}
                        {currentTable === 'matches' ? (
                            <table className="matches-table">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Matches</th>
                                        <th>Qorbi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {matchesData.map((match) => (
                                        <tr key={match._id}>
                                            <td>{match._id}</td>
                                            <td>{match.matchCount}</td>
                                            <td>{match.matchCount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <table className="matches-table">
                                <thead>
                                    <tr>
                                        <th>Username</th>
                                        <th>Matches</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {leaderSubjects.usernames.map((user) => (
                                        <tr key={user.username}>
                                            <td>{user.username}</td>
                                            <td>{user.matches}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
                <div className='second-middle-container'>
                    <div className="qorb-earning-container" style={{ opacity: !leaderSubjects && 0, userSelect: !leaderSubjects && "none", pointerEvents: !leaderSubjects && "none" }}>
                        <img src={qorbi_coin} alt="Qorbi_Coin" />
                        ‎ Referal Earning: <div style={{ color: "#0f0", marginLeft: 8 }}>{leaderSubjects && calculateMonthlyEarnings(leaderSubjects.totalEarning)} QORBI</div>
                    </div>
                    <div className="button-container-tester" style={{ opacity: 0, userSelect: "none", pointerEvents: "none" }}>
                        <button
                            className="greenBtn"
                            style={{ width: "55%", height: 50 }}
                            onClick={() => setShowPopup(true)}
                        >
                            Claim Your Posho
                        </button>
                    </div>
                    <div className="hot-news">
                        <h2>Hot News</h2>
                        {hotNews.map(news => (
                            <div key={news._id}>
                                <p>{news.simpleText} {news.link && <a style={{ color: "green" }} target='blank' href={news.link}>Go Now</a>}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BetaTester;
